module.exports = __webpack_public_path__ + "static/media/Anuksha_Koul.30c68d0f.jpg";